// extracted by mini-css-extract-plugin
export default {"details":"TDhIk"};